const CONVERSION_LABELS = {
  generate_lead: "ovShCOm3mJ0dELiBuv8C",
  click_whatsapp: "ipdTCOy3mJ0dELiBuv8C",
  click_telefono: "KPHGCO-3mJ0dELiBuv8C",
  download_brochure: "X_0BCOq4mJ0dELiBuv8C",
};

export const track = (name, params) => {
  if (!window.gtag) return;
  window.gtag("event", name, params);
  const label = CONVERSION_LABELS[name];
  if (label) window.gtag("event", "conversion", { send_to: `AW-804159672/${label}` });
};

export const grantAdsConsent = () => {
  window.gtag &&
    window.gtag("consent", "update", {
      ad_storage: "granted",
      ad_user_data: "granted",
      ad_personalization: "granted",
      analytics_storage: "granted",
    });
};
